function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#CD162D",
  d: "M38.602 3.899v32.98a3.665 3.665 0 0 1-3.665 3.665H5.621a3.665 3.665 0 0 1-3.665-3.665V3.9A3.665 3.665 0 0 1 5.621.234h29.316A3.665 3.665 0 0 1 38.602 3.9z"
}), React.createElement("path", {
  fill: "#AB002B",
  d: "M5.62 35.048h29.317a1.832 1.832 0 0 1 0 3.665H5.621a1.832 1.832 0 1 1 0-3.665z"
}), React.createElement("path", {
  fill: "#DD1E34",
  d: "M40.434 3.899v29.316a3.665 3.665 0 0 1-3.664 3.665H3.79a3.665 3.665 0 0 1-3.665-3.665V3.9A3.665 3.665 0 0 1 3.789.234h32.98A3.665 3.665 0 0 1 40.435 3.9z"
}), React.createElement("path", {
  fill: "#D01130",
  d: "M5.62 33.215h29.317a1.832 1.832 0 0 1 0 3.665H5.621a1.832 1.832 0 0 1 0-3.665z"
}), React.createElement("path", {
  fill: "#FF4957",
  d: "M40.433 3.899v20.154a3.665 3.665 0 0 1-3.664 3.665H3.789a3.665 3.665 0 0 1-3.665-3.665V3.9A3.665 3.665 0 0 1 3.788.234h32.98A3.665 3.665 0 0 1 40.434 3.9z"
}), React.createElement("path", {
  fill: "#FF2939",
  d: "M4.705 13.06h31.149a2.748 2.748 0 0 1 0 5.497H4.704a2.748 2.748 0 1 1 0-5.497z"
}), React.createElement("path", {
  fill: "#FF8791",
  d: "M3.789 2.067h32.98a1.832 1.832 0 0 1 0 3.665H3.79a1.832 1.832 0 1 1 0-3.665z"
}), React.createElement("path", {
  fill: "#FF3241",
  d: "M39.518 5.731a.916.916 0 0 0-.916.916v17.407a1.834 1.834 0 0 1-1.833 1.832H4.705a.916.916 0 0 0 0 1.832h32.064a3.665 3.665 0 0 0 3.665-3.664V6.647a.916.916 0 0 0-.916-.916z"
}), React.createElement("path", {
  fill: "#E2C6FF",
  d: "M18.446 40.544H12.95V.234h5.496z"
}), React.createElement("path", {
  fill: "#F6EDFF",
  d: "M40.434 11.228v5.496H.124v-5.496z"
}), React.createElement("path", {
  fill: "#E2C6FF",
  d: "M12.034 11.228h3.665a2.748 2.748 0 0 1 0 5.497h-3.665a2.748 2.748 0 1 1 0-5.497z"
}), React.createElement("path", {
  fill: "#F6EDFF",
  d: "M18.446 27.719H12.95V.235h5.496z"
}), React.createElement("g", {
  fill: "#E2C6FF"
}, React.createElement("path", {
  d: "M14.782 14.892h1.833a1.832 1.832 0 1 1 0 3.665h-1.833a1.832 1.832 0 1 1 0-3.665z"
}), React.createElement("path", {
  d: "M23.262 3.899c-.722 0-1.4.349-1.82.936l-8.492 11.89h5.497l6.635-9.29c1.057-1.48 0-3.536-1.82-3.536z"
})), React.createElement("path", {
  fill: "#FAF5FF",
  d: "M8.135 3.899c.722 0 1.4.349 1.82.936l8.492 11.89H12.95l-6.635-9.29c-1.058-1.48 0-3.536 1.82-3.536z"
}), React.createElement("path", {
  fill: "#D6AEFF",
  d: "M14.782 27.718h1.833a1.832 1.832 0 0 1 0 3.665h-1.833a1.832 1.832 0 0 1 0-3.665z"
}), React.createElement("path", {
  fill: "#D1A5F5",
  d: "M14.782 36.88h1.833a1.832 1.832 0 0 1 0 3.665h-1.833a1.832 1.832 0 1 1 0-3.665z"
}), React.createElement("path", {
  fill: "#FCF8FF",
  d: "M14.782 2.067h1.833a1.832 1.832 0 0 1 0 3.665h-1.833a1.832 1.832 0 1 1 0-3.665z"
}), React.createElement("path", {
  fill: "#FF8791",
  d: "M3.789 18.557c1.012 0 1.832.82 1.832 1.833v1.832a1.832 1.832 0 0 1-3.665 0V20.39c0-1.012.82-1.833 1.833-1.833z"
}), React.createElement("g", {
  fill: "#EFDEFF"
}, React.createElement("path", {
  d: "M13.866 35.048h3.665a.916.916 0 0 1 0 1.832h-3.665a.916.916 0 1 1 0-1.832zM39.517 11.228c.506 0 .917.41.917.916v3.664a.916.916 0 1 1-1.832 0v-3.664c0-.506.41-.916.915-.916zM18.446 26.802c0 .506-.41.916-.916.916h-3.664a.916.916 0 0 1 0-1.832h3.664c.506 0 .916.41.916.916zM18.447 1.15c0 .506-.41.916-.916.916h-3.665a.916.916 0 0 1 0-1.832h3.665c.506 0 .916.41.916.916z"
})));

var SvgGift = function SvgGift(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift.94a94d53.svg";
export { ForwardRef as ReactComponent };